import { __awaiter } from "tslib";
import { auth, getCustomer, getOrSetJwt, isValidCustomer, } from "../../shared/models/api";
import { isCustomerFormDisabled, setCustomerFormDisabled, } from "../../shared/models/api";
import Model from "../../shared/models/model";
import { Link } from "react-router-dom";
import React, { useState } from "react";
export const VisitorCheck = (props) => {
    const [error, setError] = useState(null);
    const [postcode, setPostcode] = useState("");
    const [customerid, setCustomerId] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const submit = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        if (postcode && customerid) {
            try {
                setError(null);
                setSubmitting(true);
                const id = parseInt(customerid);
                const jwt = yield auth(id, postcode);
                const customer = yield getCustomer(id, jwt);
                isValidCustomer(customer, props.setDataFormErrors);
                setCustomerFormDisabled(true);
                props.setCustomer(customer);
                getOrSetJwt(jwt);
            }
            catch (e) {
                setError(e);
            }
            finally {
                setSubmitting(false);
            }
        }
    });
    const reset = () => {
        setPostcode("");
        setCustomerId("");
        setCustomerFormDisabled(false);
        props.setCustomer(null);
    };
    return (React.createElement("section", { className: "visitor check" },
        React.createElement("h4", { className: "pt2" }, "Ich war schon einmal Gast"),
        React.createElement("div", { className: "radio-bar radio-bar--full mb3" },
            React.createElement("a", { href: "#", onClick: (e) => {
                    e.preventDefault();
                    Model.wasAlreadyGuest = true;
                    props.setWasAlreadyGuest(true);
                }, className: `radio-bar-item radio-bar-item-1 ${props.wasAlreadyGuest === true && "radio-bar-item--active"}` }, "Ja"),
            React.createElement("a", { href: "#", onClick: (e) => {
                    e.preventDefault();
                    Model.wasAlreadyGuest = false;
                    props.setWasAlreadyGuest(false);
                    props.setDataFormErrors({});
                    reset();
                }, className: `radio-bar-item radio-bar-item-2 ${props.wasAlreadyGuest === false && "radio-bar-item--active"}` }, "Nein")),
        props.wasAlreadyGuest && (React.createElement(React.Fragment, null,
            React.createElement("h4", null, "Abruf Ihrer Daten"),
            React.createElement("form", { className: "check-form form-box", onSubmit: (e) => submit(e) },
                (error === null || error === void 0 ? void 0 : error.status) === "wrong-username-password" && (React.createElement("p", { className: "alert alert--danger alert--icon mb2" },
                    React.createElement("i", { className: "fas fa-exclamation-triangle" }),
                    "F\u00FCr diese Angaben konnten leider keine Kundendaten gefunden werden.")),
                (error === null || error === void 0 ? void 0 : error.status) === "blocked" && (React.createElement("p", { className: "alert alert--danger alert--icon mb2" },
                    React.createElement("i", { className: "fas fa-exclamation-triangle" }),
                    "Dieser Account wurde aufgrund von zu vielen Fehlversuchen bis morgen gesperrt.")),
                React.createElement("div", { className: "row row--2er" },
                    React.createElement("label", { className: "textfield date" },
                        React.createElement("input", { id: "id", name: "id", type: "text", maxLength: 7, value: customerid, autoComplete: "customerid", placeholder: "z.B. 1234567", disabled: isCustomerFormDisabled(), onInput: (e) => {
                                const el = e.target;
                                const input = el.value;
                                if (input.match(/^[0-9]*$/)) {
                                    setCustomerId(input);
                                }
                            } }),
                        React.createElement("span", { className: "textfield__label" }, "Kundennummer")),
                    React.createElement("label", { className: "textfield date" },
                        React.createElement("input", { id: "post", type: "text", name: "post", maxLength: 9, value: postcode, autoComplete: "postcode", placeholder: "z.B. 1234567", disabled: isCustomerFormDisabled(), onInput: (e) => {
                                const el = e.target;
                                const input = el.value;
                                if (input.match(/^[0-9-a-zA-Z]*$/)) {
                                    setPostcode(input);
                                }
                            } }),
                        React.createElement("span", { className: "textfield__label" }, "Postleitzahl"))),
                React.createElement("div", { className: "tr" },
                    React.createElement("button", { type: "button", className: "btn btn--secondary mr2", disabled: !isCustomerFormDisabled(), onClick: () => reset() },
                        React.createElement("i", { className: "fas fa-trash mr2" }),
                        "Zur\u00FCcksetzen"),
                    React.createElement("button", { type: "submit", className: "btn btn--secondary", disabled: submitting ||
                            !postcode ||
                            !customerid ||
                            isCustomerFormDisabled() },
                        submitting ? (React.createElement("i", { className: "fas fa-spinner fa-spin mr2" })) : (React.createElement("i", { className: "fas fa-download mr2" })),
                        "Pr\u00FCfen"))),
            !isCustomerFormDisabled() && (React.createElement("div", { className: "mt3" },
                React.createElement(Link, { to: props.backlink, className: "btn btn--link" },
                    React.createElement("i", { className: "fas fa-arrow-left mr2" }),
                    "Zur\u00FCck")))))));
};
export default VisitorCheck;
